import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { collapseGroupDropdown, initCollapseDropdownFilter } from '@app/helpers/scripts';
import { IDataGrouped } from '@app/interfaces/idata-grouped';
import { PlatformService } from '@app/services/platform.service';

@Component({
  selector: 'form-group-checkbox-grouped',
  templateUrl: './form-group-checkbox-grouped.component.html',
  styleUrls: ['./form-group-checkbox-grouped.component.css']
})
export class FormGroupCheckboxGroupedComponent implements OnChanges {

  @Input() formGroup: FormGroup;
  @Input() control: FormArray;
  @Input() id: string = '';
  @Input() placeholder: string = '';
  @Input() title: string = '';
  @Input() footer: string = '';
  @Input() messageRequired: string = '';
  @Input() placeholderSearch: string = '';
  @Input() dataSelect: Array<IDataGrouped> = [];
  @Input() textSelectAllGroup: string = '';
  @Input() size: 'lg' | 'default' = 'default';

  ngOnChanges(changes: SimpleChanges): void {

    if (changes['dataSelect']) {

      if (this.platformService.isPlatformBrowser && changes['dataSelect'].currentValue?.length > 0) {
        setTimeout(() => {
          initCollapseDropdownFilter(this.id);
          collapseGroupDropdown();
        }, 200);
      }
    }
  }

  constructor(
    private platformService: PlatformService) {
  }

  onChangeCheckboxAll(event: any, index: number) {

    const newValue = event.target.checked === true ? true : false;

    const fa = this.control.at(index).get('items') as FormArray;

    fa.controls.forEach(r => r.setValue(newValue, { emitEvent: false }))
    fa.updateValueAndValidity();
  }

  onChangeCheckbox(event: any, indexParent: number) {

    const element = document.getElementById(this.id + '-all-' + indexParent) as HTMLInputElement;

    if (!element)
      return;

    const fa = this.control.at(indexParent).get('items') as FormArray;

    element.checked = fa.controls.every(control => control.value === true);
  }

  uncheckOptionAll() {
    const checkboxes = document.getElementById(this.id + '-dp').getElementsByClassName('every-check') as HTMLCollectionOf<HTMLInputElement>;

    for (let i = 0; i < checkboxes.length; i++) {
      checkboxes[i].checked = false;
    }
  }

  resetFormControl() {

    this.control.controls.forEach((group: FormGroup) => {
      const itemsArray = group.get('items') as FormArray;
      itemsArray.controls.forEach(control => control.reset(false, { emitEvent: false }));
    });

    this.uncheckOptionAll();
  }

}